import Vue from "vue";
import Router from "vue-router";
const home = () => import("../views/home");
const layout = () => import("@/views/layout");
const TermsOfUse = () => import("@/views/TermsOfUse");
const PrivacyPolicy = () => import("@/views/PrivacyPolicy");

Vue.use(Router);
const router = new Router({
  mode: "history", //这个模式下，地址栏就不会自己加上#号了
  routes: [
    {
      name: "home",
      path: "/",
      component: home,
      meta: {
        title: "Eleven11",
      },
    },
    {
      name: "TermsOfUse",
      path: "/TermsOfUse",
      component: TermsOfUse,
      meta: {
        title: "TermsOfUse",
      },
    },
    {
      name: "PrivacyPolicy",
      path: "/PrivacyPolicy",
      component: PrivacyPolicy,
      meta: {
        title: "PrivacyPolicy",
      },
    },
  ],
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  next();
});

export default router;
